import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../lib/api';

interface ShareInfo {
  fileName: string;
  sizeBytes: number;
  mimeType: string | null;
  downloadUrl: string;
}

function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

const s = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' } as const,
  card: { background: '#fff', borderRadius: '8px', padding: '2.5rem', width: '360px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)', textAlign: 'center' as const },
  icon: { fontSize: '3rem', marginBottom: '1rem' },
  title: { fontSize: '1.1rem', fontWeight: 600, color: '#111827', marginBottom: '0.25rem', wordBreak: 'break-all' as const },
  meta: { fontSize: '0.8rem', color: '#6b7280', marginBottom: '1.5rem' },
  btn: { display: 'inline-block', padding: '0.65rem 1.5rem', background: '#1a1a1a', color: '#fff', borderRadius: '6px', border: 'none', fontSize: '0.9rem', cursor: 'pointer', textDecoration: 'none' } as const,
  err: { color: '#333333', fontWeight: 600, fontSize: '0.9rem' },
};

export function SharePage(): JSX.Element {
  const { token } = useParams<{ token: string }>();
  const [info, setInfo] = useState<ShareInfo | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE_URL}/share/${token}`)
      .then((r) => r.json())
      .then((res) => {
        if (res.success) setInfo(res.data);
        else setError('このリンクは無効または期限切れです。');
      })
      .catch(() => setError('読み込みに失敗しました。'))
      .finally(() => setLoading(false));
  }, [token]);

  const icon = info?.mimeType?.startsWith('image/') ? '🖼️'
    : info?.mimeType?.startsWith('video/') ? '🎬'
    : info?.mimeType === 'application/pdf' ? '📄'
    : '📎';

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        {loading && <p style={s.meta}>読み込み中…</p>}
        {error && <p style={s.err}>{error}</p>}
        {info && (
          <>
            <div style={s.icon}>{icon}</div>
            <p style={s.title}>{info.fileName}</p>
            <p style={s.meta}>{formatBytes(info.sizeBytes)}</p>
            <a style={s.btn} href={info.downloadUrl}>ダウンロード</a>
          </>
        )}
      </div>
    </div>
  );
}
